import dayjs, { type Dayjs } from 'dayjs'
import { useTimezone } from 'common/hooks/useTimezone'
import { DateService } from 'common/services/dateService'
import styles from './resourceHeader.module.scss'

type Props = {
  date: Date | Dayjs
}

const { getCurrentTimeInTimezone } = DateService

export const ResourceHeader = ({ date }: Props) => {
  const { timeZone } = useTimezone()
  const day = dayjs(date)
  const isToday = timeZone
    ? day.isSame(getCurrentTimeInTimezone(timeZone), 'day')
    : day.isSame(dayjs(), 'day')

  return (
    <div className={styles.head}>
      <span className={isToday ? styles.todayName : undefined}>{day.format('ddd MM/DD')}</span>
      {isToday ? <span className={styles.todayTag}>Today</span> : null}
    </div>
  )
}
